
import Modal from "react-bootstrap/Modal";
import React from 'react'
import { GenericBtn } from "pages/finance/v2/FinanceRequest";

const ConfirmAccountDetails = ({ show, closeModal, category = "Invoice", onSubmit }) => {
    return (
        <Modal
            show={show}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            className="border-0 "
            onHide={closeModal}
        >
            <Modal.Body
                style={{
                    borderRadius: "16px",
                    padding: "0px",
                    border: "none",
                }}
                className="bg-white rounded-md"
            >
                <div className="w-full gap-4 px-4 py-4 ">
                    <div className="flex items-center justify-between">
                        <h5 className="text-xl font-semibold text-gray-90">
                            You need to add payment information
                        </h5>

                        <span
                            className="cursor-pointer material-icons"
                            style={{ color: "#667085" }}
                            onClick={closeModal}
                        >
                            close
                        </span>
                    </div>
                    <p className="text-base font-normal text-gray-50">
                        This {category} doesn’t have any payment information on record
                    </p>
                </div>
                <div
                    className="flex items-center justify-end px-4 py-3 gap-x-5"
                    style={{
                        borderTop: "1px solid #E7E9FB",
                    }}
                >
                    <GenericBtn disabled={false} onClick={onSubmit} text="Continue" />
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default ConfirmAccountDetails